/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from '@emotion/react';
import { FONT_FAMILY } from "../../../constants";

export const useStyles = () => ({
  paper: css({
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
    fontFamily: FONT_FAMILY.ROBOTO_LIGHT,
  }),
});
